
// export const logout = ( state ) => {
// }

export const setStafferstype = (state, stafferstype) => {
    state.stafferstype = stafferstype
}

export const setStafferstypeSelectable = (state, stafferstype) => {
    state.stafferstypeSelectable = stafferstype
}

export const setStafferstypePaginated = (state, stafferstypePaginatedData) => {
    state.stafferstypePaginatedData = stafferstypePaginatedData
}

export const setStaffertypeDetail = (state, staffertype) => {
    state.staffertype = staffertype
}

export const saveNewStafferstype = (state, staffertype) => {
    state.stafferstype.unshift(staffertype)
    state.createdData = staffertype;
}

export const saveUpdatedStaffertype = (state, staffertype) => {
    state.stafferstype.unshift(staffertype)
    state.updatedData = staffertype;
}

export const setDeleteStaffertype = (state, staffertype) => {
    
    state.stafferstypePaginatedData.data.filter(x => x.id !== staffertype.id);
    state.deletedData = staffertype
}

export const setStaffertypeIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setStaffertypeIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setStaffertypeIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setStaffertypeIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
